import React, { Component } from 'react';
import styled from 'styled-components';
import { DropdownList } from 'react-widgets';

import { colors } from '../../../shared/styles';

import Button from '../Button';

const StyledContactPicker = styled.div`
    color: ${colors.grey.default};
    padding: 10px 20px;

    & table {
        width: 100%;
        max-width: 100%;
        border: solid 1px ${colors.offWhite};
        margin-bottom: 20px;
        border-collapse: collapse;
        border-spacing: 0;
        text-align: left;
    }

    & tbody,
    & tfoot,
    & thead,
    & tr,
    & th,
    & td {
        margin: 0;
        padding: 0;
        border: 0;
        font-size: 100%;
        vertical-align: baseline;
        border-collapse: collapse;
        border-spacing: 0;
        vertical-align: middle;
        text-align: left;
    }

    thead {
        background: #e4e8e9;
        overflow: hidden;
        border-bottom: 1px solid #d9d9db;
    }

    th {
        box-sizing: border-box;
        width: calc((100% - 100px) / 3);
        font-weight: normal;
        text-align: left;
        padding: 15px 20px;

        &:last-of-type {
            width: 95px;
        }
    }

    tbody {
        tr {
            font-weight: lighter;
            background: #f3f3f5;

            &:nth-of-type(odd) {
                background: ${colors.white};
            }
        }
    }

    td {
        padding: 15px 20px;
        white-space: nowrap;
        vertical-align: middle;
    }

    & .contact-picker .picker {
        max-width: 50%;
        margin-bottom: 20px;
    }

    & .rw-dropdownlist {
        height: 41px;
        box-sizing: border-box;
        border: solid 1px ${colors.offWhite};
        border-radius: 4px;
        font-size: 14px;
        margin: 0;
        appearance: menulist;
    }

    & .rw-dropdownlist > .rw-input {
        height: 39px;
        border-radius: 4px;
        padding: 6px 10px;
        font-size: 14px;
    }

    & .rw-dropdownlist .rw-list .rw-state-focus {
        background: ${colors.offWhite};
    }

    &.input-error {
        & .input-wrapper {
            border-color: ${colors.error.default};
        }

        span {
            display: block;
            color: ${colors.error.default};
            font-size: 13px;
            margin-top: 5px;
        }
    }

    & .rw-widget-picker > * {
        width: auto;
    }

    & .rw-input {
        input {
            width: 100%;
        }
    }

    & .rw-select {
        width: 1.9em;
        padding: 0 !important;

        > * {
            width: 1.9em;
            height: 100%;
        }
    }

    & .rw-filter-input {
        width: calc(100% - 8px);
    }

    & .contact-picker .rw-dropdown-list-input {
        max-width: 100%;
    }

    & .contact-picker .rw-select {
        max-width: 100%;
        padding: 0 10px;
        text-align: right;
    }
`;

class ContactPicker extends Component {
    constructor(props) {
        super(props);

        this.state = {
            currentlySelectedContact: null,
        };

        this.onAddContact = this.onAddContact.bind(this);
        this.onRemove = this.onRemove.bind(this);
        this.onSelectContact = this.onSelectContact.bind(this);
    }

    onAddContact() {
        const { input: { value, onChange } } = this.props;

        onChange([...value, this.state.currentlySelectedContact]);

        this.setState({
            currentlySelectedContact: null,
        });
    }

    onRemove(contactId) {
        const { input: { value, onChange } } = this.props;

        return onChange(
            value.filter(contact => {
                return contact.contactId !== contactId;
            })
        );
    }

    onSelectContact(contact) {
        this.setState({
            currentlySelectedContact: contact,
        });
    }

    render() {
        const {
            contactList,
            disabled,
            input,
            meta: { touched, error },
        } = this.props;

        const currentlySelectedContact = this.state.currentlySelectedContact;

        const errorClass = touched && error ? 'input-error' : '';
        const selectedContacts = Array.isArray(input.value) ? input.value : [];
        const selectedContactIds = selectedContacts.map(
            contact => contact.contactId
        );

        const selectableContacts = Array.isArray(contactList)
            ? contactList.filter(contact => {
                  return selectedContactIds.indexOf(contact.contactId) < 0;
              })
            : [];

        return (
            <StyledContactPicker className={errorClass}>
                {selectedContacts.length > 0 &&
                    <table className="contact-list">
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Telephone</th>
                                <th>Email</th>
                                <th />
                            </tr>
                        </thead>
                        <tbody>
                            {selectedContacts.map((contact, index) => {
                                return (
                                    <tr key={`${index}.${contact.contactId}`}>
                                        <td>
                                            {contact.contactForenames}{' '}
                                            {contact.contactSurname}
                                        </td>
                                        <td>
                                            {contact.contactTelephone}
                                        </td>
                                        <td>
                                            <a
                                                href={`mailto:${contact.contactEmail}`}
                                            >
                                                {contact.contactEmail}
                                            </a>
                                        </td>
                                        <td>
                                            <Button
                                                type="button"
                                                disabled={disabled}
                                                onClick={e => {
                                                    this.onRemove(
                                                        contact.contactId
                                                    );
                                                }}
                                            >
                                                Remove
                                            </Button>
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>}
                <div className="contact-picker">
                    <div className="picker">
                        <DropdownList
                            valueField="contactId"
                            textField="fullName"
                            data={selectableContacts}
                            filter="contains"
                            onChange={this.onSelectContact}
                            value={
                                currentlySelectedContact
                                    ? currentlySelectedContact.contactId
                                    : null
                            }
                            placeholder="Select another contact to add..."
                        />
                    </div>

                    <div>
                        <Button
                            type="button"
                            disabled={disabled}
                            onClick={this.onAddContact}
                        >
                            Add Contact
                        </Button>
                    </div>
                </div>

                {touched &&
                    error &&
                    <span>
                        {error}
                    </span>}
            </StyledContactPicker>
        );
    }
}

export default ContactPicker;



// WEBPACK FOOTER //
// ./src/components/shared/forms/ContactPicker.js